import { Outlet } from 'react-router-dom'
import { ReactNode } from 'react'

export type UseSettingsAiAgentLayoutReturn = {
  children: ReactNode
}

export function useSettingsAiAgentLayout(): UseSettingsAiAgentLayoutReturn {
  return { children: <Outlet /> }
}
